import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /** Disables the filter's interactive controls. */
  disabled: booleanAttribute(),
  modelValue: {
    type: String,
    default: undefined,
  },
  name: {
    type: String,
    default: "date",
  },
  label: {
    type: String,
    default: "Date",
  },
  /**
   * Label shown above the calendar in the open menu.
   *
   * @type {String}
   */
  cardLabel: {
    type: String,
    default: undefined,
  },
  /**
   * The format the activator shows the chosen date in, in flatpickr tokens.
   *
   * @type {String}
   */
  displayFormat: {
    type: String,
    default: "F j, Y",
  },
  prependIcon: {
    type: String,
    default: "event-filled",
  },
  open: {
    type: Boolean,
    default: false,
  },
  /**
   * Pick a first and a last day instead of one day.
   *
   * @type {Boolean|String}
   */
  range: booleanAttribute(),
  closeOnContentClick: booleanAttribute(),
  /** Requires a date before form submission. @type {Boolean|String} */
  required: booleanAttribute(),
  /**
   * Where the calendar menu opens relative to its activator.
   *
   * @type {String}
   */
  location: {
    type: String,
    default: undefined,
  },
});
